import React, { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Box, Divider, Stack } from "@mui/material";
import { RangeSelectorControlProps } from "@hooks";
import {
  BookingTypeSetting,
  PeriodSetting,
  SettingsSectionTitle,
  SortSelect,
  useDateAmountSortOptions,
} from "@components/MobileList";
import { BookingListView } from "../BookingsTableContainer/mobile";
import {
  AssetClassSetting,
  useShowsAssetClassSetting,
} from "./AssetClassSetting";

interface Props {
  view: BookingListView;
  bookingsRangeProps: RangeSelectorControlProps;
  // Page specific controls, e.g. the currency toggle on the investments page.
  children?: ReactNode;
}

export const BookingsListSettings = ({
  view,
  bookingsRangeProps,
  children,
}: Props) => {
  const { t } = useTranslation();
  const showsAssetClass = useShowsAssetClassSetting();

  const sortOptions = useDateAmountSortOptions();

  return (
    <Stack
      divider={<Divider />}
      spacing={2}
      data-testid="bookings-list-settings"
    >
      <Stack spacing={4} px={4} py={2}>
        <PeriodSetting rangeProps={bookingsRangeProps} />
        {showsAssetClass && <AssetClassSetting />}
        <BookingTypeSetting selected={view.types} onChange={view.setTypes} />
        <SortSelect
          label={t("domains.investments.investmentTable.mobile.sortBy")}
          options={sortOptions}
          field={view.sortField}
          direction={view.sortDirection}
          onChange={view.setSort}
        />
      </Stack>
      {children && (
        <Box py={2}>
          <SettingsSectionTitle>
            {t("domains.investments.investmentTable.mobile.view")}
          </SettingsSectionTitle>
          <Stack spacing={3} px={4} alignItems="flex-start">
            {children}
          </Stack>
        </Box>
      )}
    </Stack>
  );
};
